export default (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
